<template>
  <ul class="list-options">
    <li v-for="opt in options" :key="opt" class="mt-3 flex">
      <span class="inline-block align-middle mr-4">
        <img v-if="selected(opt)" src="@/assets/img/icon_check.svg">
        <img v-else src="@/assets/img/icon_circle_gray.svg">
      </span>
      <span class="inline-block align-middle">
        <div>{{ $t(`warehouse.${opt}`) }}</div>
        <div v-if="isSlotAvailable(opt)">
          <!-- Content to show if the named slot exists -->
          <slot :name="opt" />
        </div>
      </span>
    </li>
  </ul>
</template>

<script>
export default {
  props: {
    options: { type: Array, required: true },
    selections: { type: Array, default: () => [] }
  },
  methods: {
    selected (opt) {
      return this.selections && this.selections.includes(opt);
    },
    isSlotAvailable (slotName) {
      return !!this.$slots[slotName];
    }
  }
};
</script>
